// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fixture-week-days-selector__content {
    text-align: center;
    border-bottom: 1px solid var(--new-gray-background-color);
    padding-bottom: 16px;
    margin-top: 24px;
}

.fixture-week-days-selector__button.MuiToggleButton-root{
    padding: 12px;
    text-transform: unset;
    color: var(--primary-very-dark-color);
    font-weight: var(--font-regular);
    border-radius: 9px;
    border: 1px solid var(--new-gray-background-color);
    line-height: normal;
}

.fixture-week-days-selector__button.MuiToggleButton-root:hover,
.fixture-week-days-selector__button.MuiToggleButton-root.Mui-selected,
.fixture-week-days-selector__button.MuiToggleButton-root.Mui-selected:hover {
    background-color: var(--new-green-color);
    color: var(--white-color);
    border: none;
}

.fixture-week-days-selector__button.MuiToggleButton-root.Mui-selected + .fixture-week-days-selector__button.MuiToggleButton-root.Mui-selected {
    margin-left: 8px;
    border-left: 1px solid var(--new-gray-background-color);
}

.fixture-week-days-selector__time {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
}

.fixture-week-days-selector__time-group {
    display: flex;
    align-items: center;
    gap: 8px;
}

.fixture-week-days-selector__time-input {
    border: 1px solid var(--new-gray-background-color);
    border-radius: 8px;
    padding: 12px 8px;
}

.fixture-week-days-selector__time-input.baloa-username,
.fixture-week-days-selector__time-label.baloa-username {
    color: var(--primary-very-dark-color);
}
`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/tournament-fixture-week-days-selector/TournamentFixtureWeekDaysSelectorComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,yDAAyD;IACzD,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,qCAAqC;IACrC,gCAAgC;IAChC,kBAAkB;IAClB,kDAAkD;IAClD,mBAAmB;AACvB;;AAEA;;;IAGI,wCAAwC;IACxC,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,uDAAuD;AAC3D;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,kDAAkD;IAClD,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;;IAEI,qCAAqC;AACzC","sourcesContent":[".fixture-week-days-selector__content {\n    text-align: center;\n    border-bottom: 1px solid var(--new-gray-background-color);\n    padding-bottom: 16px;\n    margin-top: 24px;\n}\n\n.fixture-week-days-selector__button.MuiToggleButton-root{\n    padding: 12px;\n    text-transform: unset;\n    color: var(--primary-very-dark-color);\n    font-weight: var(--font-regular);\n    border-radius: 9px;\n    border: 1px solid var(--new-gray-background-color);\n    line-height: normal;\n}\n\n.fixture-week-days-selector__button.MuiToggleButton-root:hover,\n.fixture-week-days-selector__button.MuiToggleButton-root.Mui-selected,\n.fixture-week-days-selector__button.MuiToggleButton-root.Mui-selected:hover {\n    background-color: var(--new-green-color);\n    color: var(--white-color);\n    border: none;\n}\n\n.fixture-week-days-selector__button.MuiToggleButton-root.Mui-selected + .fixture-week-days-selector__button.MuiToggleButton-root.Mui-selected {\n    margin-left: 8px;\n    border-left: 1px solid var(--new-gray-background-color);\n}\n\n.fixture-week-days-selector__time {\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n}\n\n.fixture-week-days-selector__time-group {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.fixture-week-days-selector__time-input {\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 8px;\n    padding: 12px 8px;\n}\n\n.fixture-week-days-selector__time-input.baloa-username,\n.fixture-week-days-selector__time-label.baloa-username {\n    color: var(--primary-very-dark-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
